import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import { getFrontendFunctionsBaseUrl } from '@src/config';
import creatorSdk from '@src/services/creator-sdk';
import type { Post } from '@src/store/contentEntities/model';
import { jotaiStore } from '../store';
import { type PostCollectionCompositeKeyParams, postCollectionAtomFamily, setPost } from './posts';
// Interface remains the same
export interface PinPostApiRequestPayload {
    postId: string;
    isPinned: boolean;
    tokenName: string;
    userId: string;
}

// Helper function remains useful
const updatePinnedPostIds = (currentPinnedPostIds: string[], post: Post): string[] => {
    if (post.isPinned) return [post.id, ...currentPinnedPostIds];
    // If unpinning, filter it out if it exists.
    return currentPinnedPostIds.filter(id => id !== post.id);
};

export const pinPost = async (payload: PinPostApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();

    const { data } = await postApi<ApiResponse<Post>>(
        '/post/pin',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );

    const post = data.payload; // This is the updated post from the API
    const { tokenName } = post;

    setPost(post);

    const params: PostCollectionCompositeKeyParams = {
        type: 'pinned',
        tokenName,
    };

    const pinnedCollectionAtom = postCollectionAtomFamily(params);

    jotaiStore.set(pinnedCollectionAtom, draft => {
        draft.ids = updatePinnedPostIds(draft.ids || [], post);
    });

    // Temp fix
    const cacheKey = `pinnedPosts_${tokenName}`;
    fetch(`${getFrontendFunctionsBaseUrl()}/cache?key=${cacheKey}`, { method: 'DELETE' });

    return post;
};
